import { useState } from 'react';
import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 max-w-[1440px] mx-auto">
      <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 text-center">
        热门韩漫推荐 ✦
      </h2>

      <div className="mt-12 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
        {featuredComics.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
              expandedIndex === index
                ? 'md:col-span-2'
                : 'md:col-span-1'
            }`}
            style={{ height: '420px' }}
            onMouseEnter={() => setExpandedIndex(index)}
            onMouseLeave={() => setExpandedIndex(0)}
            data-product-shop=""
          >
            <img
              src={comic.coverImage}
              alt={`${comic.title} - ${comic.category}韩国漫画`}
              title={`${comic.title} - 免费韩漫在线阅读`}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

            {/* Status badge */}
            <span className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-medium ${
              comic.status === '连载中'
                ? 'bg-accent-500 text-foreground-950'
                : 'bg-secondary-500 text-background-50'
            }`}>
              {comic.status}
            </span>

            {/* Rating */}
            <span className="absolute top-4 right-4 px-3 py-1 rounded-full bg-black/40 backdrop-blur-sm text-white text-xs font-medium">
              ★ {comic.rating}
            </span>

            {/* Bottom info */}
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white">
                {comic.title}
              </h3>
              <p className={`mt-2 text-sm text-white/70 leading-relaxed transition-all duration-500 ${
                expandedIndex === index ? 'opacity-100 max-h-20' : 'opacity-0 max-h-0 md:opacity-0'
              }`}>
                {comic.description}
              </p>
              <div className="mt-3 flex items-center gap-4 text-xs text-white/60">
                <span>{comic.author}</span>
                <span>{comic.latestChapter}</span>
                <span>{comic.views.toLocaleString()} 阅读</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}